import { Component, Input, OnInit } from '@angular/core';
import { Party } from 'app/event/models/party';
import { OnyxEvent } from '../models/event';
import { InvoiceHistoryVendor } from '../models/invoice-history-vendor';
import { InvoiceHistoryStore } from '../service/invoice-history.store';
import { EnvironmentConfiguration } from 'app/environment/services/environment.configuration';

@Component({
  selector: 'pioneer-invoice-history-vendor-card',
  templateUrl: './invoice-history-vendor-card.component.html',
  styleUrls: ['./invoice-history-vendor-card.component.css']
})
export class InvoiceHistoryVendorCardComponent implements OnInit {

  @Input() vendors: Party[];

  @Input() vendor: Party;

  @Input() event: OnyxEvent;

  invoiceVendor: InvoiceHistoryVendor;

  public token: string;

  public imagesUrl= '';

  constructor (
    private invoiceHistoryStore: InvoiceHistoryStore,
    private environment: EnvironmentConfiguration
  ) {

  }

  ngOnInit() {
    this.imagesUrl = this.environment.onyxGPImagesCommonDataUrl;

    this.disableAll();
  }

  public onCardExpandClicked(event: Event, eventPartyId: number
                           , chain: string, brand: string, propertyId: string, expanded: boolean): void {
    event.preventDefault();
    if (eventPartyId) {
      this.vendors.filter(ve => ve.eventPartyId === eventPartyId).forEach(x => {
        x.isExpanded = expanded;
        if (x.isExpanded) {
          this.getVendorToken();
        }
      });
    } else {
      this.vendors.filter(ve => ve.chain === chain && ve.brand === brand && ve.propertyId === propertyId).forEach(x => {
        x.isExpanded = expanded;
        if (x.isExpanded) {
          this.getVendorToken();
        }
      });
    }
    if (expanded && this.vendors.length > 1) {
      this.disableOthers(eventPartyId, chain, brand, propertyId);
    }
  }

  private getVendorToken() {
    this.invoiceVendor = new InvoiceHistoryVendor({
      'chain': this.vendor.chain,
      'brand': this.vendor.brand,
      'pid': this.vendor.propertyId
    });

    this.invoiceHistoryStore.getInvoiceHistoryEventAgencyVendorAuth(this.event.eventId, this.invoiceVendor).subscribe(token => {
      this.token = token;
    });
  }

  private disableOthers(eventPartyId: number, chain: string, brand: string, propertyId: string): void {
    if (eventPartyId) {
      this.vendors.filter(ve => ve.eventPartyId !== eventPartyId).forEach(x => {
        x.isExpanded = false;
      });
    } else {
      this.vendors.filter(ve => ve.chain !== chain || ve.brand !== brand || ve.propertyId !== propertyId).forEach(x => {
        x.isExpanded = false;
      });
    }
  }

  private disableAll(): void {
    this.vendors.forEach(x => {
      x.isExpanded = false;
    });
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/invoice-history-vendor-card/invoice-history-vendor-card.component.ts